import type { ExtractDialogStep } from '../hooks/useStandardSectionExtraction'
import type { StandardExtractSection } from '@/shared/hooks/api/userStandards'

const EXTRACT_DIALOG_TITLE_KEYS: Record<StandardExtractSection, string> = {
  scope: 'detail.extractDialog.titleScope',
  significantHazards: 'detail.extractDialog.titleSignificantHazards',
  riskReductionMeasures: 'detail.extractDialog.titleRiskReductionMeasures',
  informationForUse: 'detail.extractDialog.titleInformationForUse',
}

export function resolveExtractDialogTitle(
  dialogStep: ExtractDialogStep,
  section: StandardExtractSection,
  translate: (key: string) => string
): string {
  if (dialogStep === 'extract') {
    return translate(EXTRACT_DIALOG_TITLE_KEYS[section])
  }
  if (dialogStep === 'acknowledgeNotFound') {
    return translate('detail.extractDialog.titleAcknowledgeNotFound')
  }
  if (dialogStep === 'review') {
    return translate('detail.extractDialog.titleReview')
  }
  if (dialogStep === 'translate') {
    return translate('detail.extractDialog.titleTranslate')
  }
  if (dialogStep === 'reviewTranslations') {
    return translate('detail.extractDialog.titleReviewTranslations')
  }
  return translate('detail.extractDialog.titleSave')
}
